import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Switch,
  FormControlLabel,
  Chip,
  Box,
} from "@mui/material";
import { db,storage } from "../firebase-config";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { getStorage, ref, getDownloadURL,getBytes, uploadString } from "firebase/storage";
import ReactCodeMirror from "@uiw/react-codemirror";
import { html } from "@codemirror/lang-html";
import { oneDark } from "@codemirror/theme-one-dark";
import Page404 from "./Page404"; // Import 404 page

const EditTool = () => {
  const { toolid } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState([]);
  const [currentTag, setCurrentTag] = useState("");
  const [isPublic, setIsPublic] = useState(true);
  const [fileContent, setFileContent] = useState("");
  const [toolExists, setToolExists] = useState(true); // Track if tool exists


  useEffect(() => {
    const fetchTool = async () => {
      try {
        // Fetch metadata from Firestore
        const toolDoc = await getDoc(doc(db, "tools", toolid));
        if (toolDoc.exists()) {
          const toolData = toolDoc.data();
          setTitle(toolData.title || "");
          setDescription(toolData.description || "");
          setTags(toolData.tags || []);
          setIsPublic(toolData.isPublic || false);

          // Fetch the file content from Firebase Storage
          const filePath = `/tools/${toolid}`;
          const fileRef = ref(storage, filePath);

          
  console.log("Start");
// Get the download URL
getDownloadURL(fileRef)
.then(async (url) => {


  console.log(url);

  const response = await fetch(url);
          if (!response.ok) {
            throw new Error("Failed to fetch file content.");
          }
          const content = await response.text();
          setFileContent(content);
  // Insert url into an <img> tag to "download"
})
.catch((error) => {
  console.log(error);
  // A full list of error codes is available at
  // https://firebase.google.com/docs/storage/web/handle-errors
  switch (error.code) {
    case 'storage/object-not-found':
      // File doesn't exist
      break;
    case 'storage/unauthorized':
      // User doesn't have permission to access the object
      break;
    case 'storage/canceled':
      // User canceled the upload
      break;

    // ...

    case 'storage/unknown':
      // Unknown error occurred, inspect the server response
      break;
  }
});


          
          //const fileBytes = await getBytes(fileRef); // Download file as bytes
          //const content = new TextDecoder("utf-8").decode(fileBytes); // Decode bytes to string
          //setFileContent(content);
        } else {
          setMessage("Tool not found.");
          setToolExists(false); // Mark tool as not found

        }
      } catch (error) {
        console.error("Error loading tool:", error);
        setMessage("Error loading tool: " + error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTool();
  }, [toolid, storage]);

  const handleAddTag = () => {
    if (currentTag.trim() && !tags.includes(currentTag.trim())) {
      setTags((prevTags) => [...prevTags, currentTag.trim()]);
      setCurrentTag("");
    }
  };

  const handleDeleteTag = (tagToDelete) => {
    setTags((prevTags) => prevTags.filter((tag) => tag !== tagToDelete));
  };

  const handleSubmit = async () => {
    if (!title) {
      setMessage("Please provide a title.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      // Update Firestore metadata
      await updateDoc(doc(db, "tools", toolid), {
        title,
        description,
        tags,
        isPublic,
      });

      // Upload updated HTML content to Firebase Storage
      const fileRef = ref(storage, `tools/${toolid}`);
      await uploadString(fileRef, fileContent, "raw");

      setMessage("Tool updated successfully!");
      navigate(`/tool/${toolid}`); // Redirect to tool view page
    } catch (error) {
      setMessage("Error updating tool: " + error.message);
    } finally {
      setLoading(false);
    }
  };


  if (!toolExists) {
    return <Page404 />; // Show 404 page if the tool does not exist
  }


  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Container maxWidth="sm">
      <Typography variant="h4" gutterBottom>
        Edit Tool
      </Typography>

      <TextField
        label="Tool Title"
        fullWidth
        margin="normal"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      <TextField
        label="Description"
        fullWidth
        margin="normal"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />

      <Box mt={2}>
        <Typography variant="body1" gutterBottom>
          Tags
        </Typography>
        <Box display="flex" gap={1} alignItems="center">
          <TextField
            label="Add Tag"
            value={currentTag}
            onChange={(e) => setCurrentTag(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && handleAddTag()}
          />
          <Button variant="contained" onClick={handleAddTag}>
            Add Tag
          </Button>
        </Box>
        <Box mt={1} display="flex" gap={1} flexWrap="wrap">
          {tags.map((tag, index) => (
            <Chip
              key={index}
              label={tag}
              onDelete={() => handleDeleteTag(tag)}
              color="primary"
            />
          ))}
        </Box>
      </Box>

      <FormControlLabel
        control={
          <Switch
            checked={isPublic}
            onChange={(e) => setIsPublic(e.target.checked)}
            color="primary"
          />
        }
        label="Public"
      />

      <Box mt={2}>
        <Typography variant="body1" gutterBottom>
          Edit HTML File
        </Typography>
        <ReactCodeMirror
          value={fileContent}
          extensions={[html()]}
          theme={oneDark}
          onChange={(value) => setFileContent(value)}
        />
      </Box>

      {message && (
        <Typography variant="body1" color="secondary" style={{ marginTop: "20px" }}>
          {message}
        </Typography>
      )}

      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        style={{ marginTop: "20px" }}
      >
        Save Changes
      </Button>
    </Container>
  );
};

export default EditTool;
